import React from 'react';
import { CreateModifierState } from './createModifierState/CreateModifierState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const CreateModifierPageV2: React.FC = () => {
	return (
		<CreateModifierState>
			<Forms />
			<ModalWindows />
		</CreateModifierState>
	);
};
